import { FunctionComponent, Suspense, lazy } from 'react'

import { LoadingTurbo } from 'atoms'

import { RVCalculators2026Props } from './RVCalculators2026.types'
import { useRVCalculators2026 } from './useRVCalculators2026'

const RVCalculators2026Desktop = lazy(() => import('./RVCalculators2026.desktop'))

export const RVCalculators2026: FunctionComponent<RVCalculators2026Props> = (props) => {
  const rvCalculators = useRVCalculators2026(props)

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <RVCalculators2026Desktop {...rvCalculators} />
    </Suspense>
  )
}
